import { render, staticRenderFns } from "./intro-item.vue?vue&type=template&id=4c611d20&scoped=true&"
import script from "./intro-item.vue?vue&type=script&lang=js&"
export * from "./intro-item.vue?vue&type=script&lang=js&"
import style0 from "./intro-item.vue?vue&type=style&index=0&id=4c611d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c611d20",
  null
  
)

export default component.exports